
import React from "react";


interface Props {

}

interface State {

}

export default class AffiliatesReportRevenueView extends React.Component<Props,State>{
   
    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return <div></div>
    }
}